export enum DeliveryMethod {
    eTicket = 'electronic',
    willCall = 'will_call',
    standardShipping = 'standard_shipping',
}
